<script>
export default {
    mounted(){
        this.$router.push('dashboard')
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/analytics.vue